import React from 'react';
import Chips from 'relements/build/esm/input/chips';
import Text from 'relements/build/esm/ui/text';
import Box from 'relements/build/esm/ui/box';
import Tooltip from 'relements/build/esm/overlays/tooltip';
import InfoIconV4 from 'relements/build/esm/ui/icons/InfoIconV4';
import { AlertTypes } from '@src/constants/MogamboConstants';
import { isProduction } from '@src/utils';
import BotStore from '@src/store';
import { createAlert } from '../maps';
import { validateUrl } from '../../../../BusinessManager/utils/validators/constants';

const renderInfoContent = () => {
  return (
    <Box padding="0" marginLeft="10px" gridGap="4px" flexDirection="column">
      <Text variant="body.md" color="black.haptik">
        1. The CORS Whitelisted Domains listed here apply to all bots under your
        account. They are not limited to just this bot.
        <br />
        2. Please allow a few minutes for these configurations to become active.
      </Text>
    </Box>
  );
};

function WhiteListDomain({ onChange = () => {}, whiteListedDomains = [] }) {
  const isCorsHeaderEnabled = BotStore.getIsCorsEnabled();
  const [value, setValue] = React.useState([]);
  const [errorChips, setErrorChips] = React.useState([]);

  React.useEffect(() => {
    setValue([...whiteListedDomains]);
    const errorIndexs = [];
    whiteListedDomains.forEach((domain, i) => {
      if (!validateUrl(domain)) errorIndexs.push(i);
    });
    setErrorChips([...errorIndexs]);
  }, [whiteListedDomains]);

  const handleChange = (val = []) => {
    if (val.length <= 15) {
      setValue(val);
      onChange(val);
    } else {
      createAlert(
        'Apologies, but you can only add up to 15 domains in the CORS list.',
        null,
        AlertTypes.NEGATIVE
      );
    }
  };

  if (!isCorsHeaderEnabled) return null;

  return (
    <Box
      flexDirection="column"
      padding="24px 14px"
      width="580px"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="#eee"
      borderRadius="md"
      marginBottom="24px"
    >
      <Box
        padding="0"
        marginBottom="16px"
        style={{ fontSize: '18px', fontWeight: '500' }}
      >
        CORS Whitelisted Domain
        <Tooltip
          themed
          size="large"
          tooltip="Protect your bot's security with CORS  (Cross-Origin Resource Sharing) whitelisting, limiting its function to approved domains for added safety."
          position="TOP"
        >
          <InfoIconV4 size="small" iconColor="grey.dark" marginLeft="6px" />
        </Tooltip>
      </Box>

      <Box
        backgroundColor="yellow.pastel"
        borderRadius="sm"
        width="fit-content"
        padding="12px"
        alignItems="center"
        marginBottom="16px"
      >
        <div>
          <InfoIconV4 size="medium" iconColor="yellow.dark" />
        </div>

        {renderInfoContent()}
      </Box>

      <Chips
        disabled={isProduction()}
        placeholder="Type and Press Enter to add..."
        label="Domain Links"
        value={value}
        onChange={handleChange}
        errorIndexes={errorChips}
        errorText="Domain Format is incorrect."
        onInputSameText={() => {
          createAlert(
            'Duplicate Domain Detected: This domain has already been added to the CORS list',
            null,
            AlertTypes.NEGATIVE
          );
        }}
      />
    </Box>
  );
}

export default WhiteListDomain;
